import {initTrustbars} from "./custom/trustbar";
import {getChildrenClassForNestedItems} from "../../../default/global/js/nav";
import {closeFilterBox, initFilter} from "../../../default/global/js/filter";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../default/global/js/actionClick";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import {stickyHeader} from "../../../default/global/js/stickyheader";
import hoverintent from "../../../default/global/js/hoverintent";
import {stickyBox} from "../../../default/global/js/stickyBox.js";
import {Tooltip} from "../../../default/global/js/tooltip";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "../../../default/global/js/mobilemenu";
import {
    excludeModal,
    triggerConfirmModalLink,
    triggerModal,
    triggerOpenLinkInModal,
    triggerOpenTextInModal
} from "../../../default/global/js/modal";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {initItemlistSlider} from "./custom/itemListSlider";
import {setSrcVideos} from "../../../default/global/js/video";
import {initScrollbars} from "./custom/scrollbar";
import {isTouchDevice} from "../../../default/global/js/touchDevice";
import {
    hideAllCustomSelect,
    hideCustomSelect,
    initCustomSelects,
    updateCustomSelectRangeFilterAction
} from "../../../default/global/js/customSelect";
import {initSearchItems} from "../../../default/global/js/searchItems";
import {trimInputValues} from "../../../default/global/js/formValidator";
import {addLoadingClassAfterSubmit} from "../../../default/global/js/utilities/updateClasses";
import {initPasswordFields} from "../../../default/global/js/password";
import {lottieLoader} from "../../../default/global/js/lottieLoader";
import {initSlidecontents} from "../../../default/global/js/slidecontent";
import {initFlashmessages} from "../../../default/global/js/flashmessages";
import {addTableWrapper} from "../../../default/global/js/tableWrapper";
import {initPhoneCountryFields} from "../../../default/global/js/phoneCountryField";
import {initInputBody} from "../../../default/global/js/inputfile";
import initDcOrder from "../../../default/global/js/dcorder";
import {initShowMoreRatings} from "../../../default/global/js/rating";
import {initInputMaskDate} from "../../../default/global/js/inputMaskDate";
import {initRecaptchaForms} from "../../../default/global/js/recaptchaForm";
import {initDatepicker} from "../../../default/global/js/datepicker";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initHistorySlider} from "../../../default/global/js/history";
import {initAjaxFormApi} from "../../../default/global/js/ajaxFormApi";
import {initScrollActivate} from "../../../default/global/js/scrollactivate";
import {initRangeslider} from "../../../default/global/js/rangeSlider";
import {initFlyout} from "../../../default/global/js/flyoutMenu";
import {initButtons} from "./custom/button";
import {initSlideshows} from "./custom/slideshow";
import {imageTextSlider} from "./custom/imageTextSlider";
import {initHighlightEditors} from "../ts/highlightEditor";
import {triggerBasketBtns, triggerUpdateBasketView} from "./custom/basket";
import {initJumpmarks} from "./custom/jumpmark";
import {initButtonFavouritesView, triggerFavoritesBtns} from "./custom/multifavorites";
import {initVideos} from "./custom/video";
import {initItemPresentation} from "./custom/itemPresentation";
import {initDirectOrder} from "../../../default/global/js/directOrder";
import {initInspirationFeeds} from "./custom/inspirationFeed";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {initAjaxCollectionFilter} from "./custom/ajaxCollectionFilter";
import {initImageGallery} from "./custom/imageGallery";
import {loadReactScript} from "../../../default/global/js/utilities/loadScript";
import {initSalesPersonSlider} from "./custom/salesPerson";
import {initSliderHighlightimages} from "./custom/sliderHighlightimages";
import {initUserlikeManipulation} from "./custom/userlikeManipulation";
import {initCategoryListPreview} from "./custom/categoryListPreview";
import {initSeotext} from "./custom/seotext";
import {initSubnav} from "./custom/subnav";
import {maxHeightContent} from "../../../default/global/js/maxHeightContent";
import {initQuantitySpinners} from "./custom/quantitySpinner";
import {initHeroBannerSlider} from "./custom/heroBannerSlider";


window.addEventListener("load", (event) => {
    initButtons();
    initHeroBannerSlider();
    initInspirationFeeds();
    initVideos();
    initSubnav();
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('.headerMain');

    let breakPointSM = 1024;
    let sendFavoriteByJS = false;
    let sendItemToBasketByJS = false;
    let updateBasketByJS = false;

    if (typeof GLOBALS !== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
        sendFavoriteByJS = GLOBALS.sendFavoriteByJS;
        sendItemToBasketByJS = GLOBALS.sendItemToBasketByJS;
        updateBasketByJS = GLOBALS.updateBasketByJS;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {
        const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

        buildMobileMenu(mobileMenu);

        mobileMenuToggle.addEventListener("click", function () {
            showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        mobileMenuClose.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            for (let filterbox of document.querySelectorAll('.filterBox')) {
                closeFilterBox(filterbox);
            }
        });
    }

    // algoliaSearch();

    //algoliaDoAutoComplete();

    initTrustbars();

    initFilter();

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    trimInputValues();

    focusInputGroups();

    initInputBody();

    initPhoneCountryFields();

    stickyHeader(stickyHeaderArea);

    if (window.innerWidth < breakPointSM) {
        for (let parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    if (sendFavoriteByJS) {
        triggerFavoritesBtns();
    }
    if (sendItemToBasketByJS) {
        triggerBasketBtns();
    }

    if (updateBasketByJS) {
        triggerUpdateBasketView();
    }

    triggerModal();
    excludeModal();
    triggerOpenLinkInModal();
    triggerConfirmModalLink();
    triggerOpenTextInModal();
    initQuantitySpinners();

    initToggleSlide();

    if (!IsTouchDevice) {
        for (let el of document.querySelectorAll('.iconbarItem')) {
            hoverintent(el);
        }
        for (let el of document.querySelectorAll('.itembox')) {
            hoverintent(el, 0);
        }
    }
    for (let el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el);
    }


    setSrcVideos();

    initSlideshows();

    initImageGallery();

    initScrollbars();

    initSlidecontents();

    initItemlistSlider(document.querySelectorAll('.itemboxList.swiper'), {
        breakpointItems: {
            xs: 1.2,
            sm: 2.2,
            md: 3.2,
            lg: 4,
            xlg: 4
        }
    });
    window.initItemlistSlider = initItemlistSlider;

    initCustomSelects();

    initRangeslider(document, function (e) {
        if (e.slider.closest(".js-customSelect")) {
            updateCustomSelectRangeFilterAction(e.slider.closest(".js-customSelect"), e.value);
        }
    });

    // Tooltip, when necessary
    function initTooltip(el) {
        if (!el._tooltipInitialized) {
          /*  el.addEventListener("click", function (e) {
                if (el.closest(".itembox")) {
                    e.preventDefault();
                }
            });*/
            new Tooltip(el, {html: true});
            el._tooltipInitialized = true; // prevent double init
        }
    }


    document.querySelectorAll('[data-toggle="tooltip"]').forEach(initTooltip);

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { // Element
                    // Direct match
                    if (node.matches('[data-toggle="tooltip"]')) {
                        initTooltip(node);
                    }
                    if (node.matches('.itembox')) {
                        if (!IsTouchDevice) {
                            for (let el of document.querySelectorAll('.itembox')) {
                                hoverintent(el, 0);
                            }
                        }
                    }
                    // Or descendants
                    node.querySelectorAll('[data-toggle="tooltip"]').forEach(initTooltip);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // End of tooltip init
    initSearchItems(document.querySelectorAll('.js-searchInput'));

    initFlashmessages();

    let offsetTopJumpmarks = 0;
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    if (typeof GLOBALS !== "undefined") {
        if (GLOBALS.offsetTopJumpmarks) {
            offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
        }
    }

    initJumpmarks(offsetTopJumpmarks);

    for (let item of document.querySelectorAll(".js-openGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
    }

    let offsetTopStickyBox = 30;
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight;
    }

    for (let pinBox of document.querySelectorAll(".js-stickyBox")) {
        stickyBox(pinBox, {
            offsetTop: offsetTopStickyBox
        });
    }
    lottieLoader();

    addLoadingClassAfterSubmit();
    initPasswordFields();

    addTableWrapper();

    initDcOrder();

    initShowMoreRatings();

    initInputMaskDate();

    initRecaptchaForms();

    initAjaxCollectionFilter();

    initDatepicker();

    initHistorySlider();
    initSalesPersonSlider();
    initCategoryListPreview();
    initSeotext();
    initContentTabs();

    initFlyout();

    initAjaxFormApi();

    initScrollActivate();

    window.main = {
        hideAllCustomSelect: function () {
            hideAllCustomSelect();
        },
        hideCustomSelect: function (select) {
            hideCustomSelect(select);
        }
    };
    initSliderHighlightimages();
    initHighlightEditors();

    initDirectOrder();
    imageTextSlider();
    initButtonFavouritesView();
    initItemPresentation();
    const chatButton = document.getElementById("openUserlikeChat");
    if (chatButton) {
        document.getElementById("openUserlikeChat").addEventListener("click", function () {
            if (typeof window.userlike === "object" && window.userlike.userlikeStartChat) {
                window.userlike.userlikeStartChat();
            } else {
                console.error("Userlike is not loaded");
            }
        });
    }

  /*  const algoliaSearchWrapper = document.getElementById("algoliaSearch");
    if (algoliaSearchWrapper) {
        loadReactScript(algoliaSearchWrapper.dataset.script);
    }*/
    maxHeightContent();
    const algoliaAutocomplete = document.getElementById("algoliaAutocomplete");
    if (algoliaAutocomplete) {
        loadReactScript(algoliaAutocomplete.dataset.script);
    }
    initUserlikeManipulation();
});